import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSubscription } from '../../contexts/SubscriptionContext';
import './WelcomeToast.css';

const WelcomeToast = () => {
  const { t } = useTranslation();
  const { showWelcomeCreditsToast, dismissWelcomeCreditsToast } = useSubscription();
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);

  const handleClose = useCallback(() => {
    setIsAnimatingOut(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsAnimatingOut(false);
      dismissWelcomeCreditsToast();
    }, 400); // match transition duration
  }, [dismissWelcomeCreditsToast]);

  useEffect(() => {
    if (showWelcomeCreditsToast) {
      setIsVisible(true);

      // Auto-dismiss after 8 seconds
      const timer = setTimeout(() => {
        handleClose();
      }, 8000);

      return () => clearTimeout(timer);
    }
  }, [showWelcomeCreditsToast, handleClose]);

  if (!isVisible) return null;

  return (
    <div className={`welcome-toast-container ${isAnimatingOut ? 'slide-out' : 'slide-in'}`}>
      <div className="welcome-toast-content">
        <div className="welcome-toast-icon">✨</div>
        <div className="welcome-toast-text">
          <h4>{t('welcomeCredits.toastTitle')}</h4>
          <p>{t('welcomeCredits.toast', { count: 5 })}</p>
        </div>
        <button
          type="button"
          className="welcome-toast-close"
          onClick={handleClose}
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default WelcomeToast;
